export const SCROLLABLE_CONTAINER_ID = 'split-layout-scrollable-container';
